<template>
  <div class="login-modern">
    <div class="login-card">
      <!-- <div class="login-logo">
      <img src="https://cdn0.archipelagointernational.com/itportal/assets/images/archipelago-logo.png" alt="Archipelago Logo" />
    </div> -->
      <h2 class="login-title">Welcome</h2>
      <h2 class="login-title">IT Portal</h2>
      <p class="login-subtitle">Sign in with your work email</p>
      <div class="login-btn-area">
        <div v-if="!isLoading" id="g_id_signin"></div>
        <div v-if="isLoading" class="login-loader">
          <div class="preloader-wrapper small active">
            <div class="spinner-layer spinner-red-only">
              <div class="circle-clipper left">
                <div class="circle"></div>
              </div>
              <div class="gap-patch">
                <div class="circle"></div>
              </div>
              <div class="circle-clipper right">
                <div class="circle"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="login-help">
        <span>Need access?</span>
        <a
          href="mailto:helpdesk@archipelagointernational.com?Subject=[Support] Request Access To IT Portal"
          >Contact IT Helpdesk</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import router from "../router";
import config from "../config.js";

export default {
  name: "login",
  data() {
    return {
      isLoading: false,
    };
  },
  mounted() {
    this.initGoogleSignIn();
  },
  methods: {
    initGoogleSignIn() {
      // Load Google Identity Services script
      if (!window.google || !window.google.accounts) {
        const script = document.createElement("script");
        script.src = "https://accounts.google.com/gsi/client";
        script.async = true;
        script.defer = true;
        script.onload = this.renderGoogleButton;
        document.head.appendChild(script);
      } else {
        this.renderGoogleButton();
      }
    },
    renderGoogleButton() {
      window.google.accounts.id.initialize({
        client_id:
          "666459687804-arockutejmu25goc9285krafg5fj0crj.apps.googleusercontent.com",
        callback: this.handleGoogleCredentialResponse,
      });
      window.google.accounts.id.renderButton(
        document.getElementById("g_id_signin"),
        { theme: "outline", size: "large", width: 250 }
      );
    },    handleGoogleCredentialResponse(response) {
      this.isLoading = true;
      let params = new URLSearchParams();
      params.append("code", response.credential);
      axios({
        method: "post",
        url: config.getApiUrl("login"),
        data: params,
      })
        .then((res) => {
          if (res.data.message == "Success") {
            // Store the JWT token, not CValue
            this.$cookies.set("arch-it-portal", res.data.token, 60 * 60 * 4);
            this.$router.push({
              name: "Dashboard",
            });
          } else {
            alert(res.data.message);
            this.isLoading = false;
          }
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style>
body {
  height: 100vh;
  min-height: 100vh;
  max-height: 100vh;
  margin: 0;
  padding: 0;
}
/* Modern, compact login styles */
.login-modern {
  min-height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 8px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
}

.login-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);
  padding: 1.5rem 1.2rem 1.2rem 1.2rem;
  max-width: 320px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;
  min-height: unset;
}

.login-logo img {
  width: 60px;
  margin-bottom: 0.3rem;
}

.login-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #00205b;
  margin: 0;
}

.login-subtitle {
  font-size: 0.95rem;
  color: #555;
  margin-bottom: 0.3rem;
}

.login-btn-area {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 0.3rem;
}

.login-loader {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 40px;
}

.login-help {
  margin-top: 0.7rem;
  font-size: 0.9rem;
  color: #888;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.1rem;
}
.login-help a {
  color: #00205b;
  text-decoration: underline;
  font-weight: 500;
}
.login-help a:hover {
  color: #d32f2f;
}

@media (max-width: 480px) {
  .login-card {
    padding: 0.7rem 0.2rem 1rem 0.2rem;
    max-width: 98vw;
  }
  .login-title {
    font-size: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue